module.exports = __webpack_public_path__ + "9be433781ad5abc12995fd645522a353.svg";